import { BaseEntity } from '@/actions/dtos/baseEntity';
import { Address } from '@/actions/dtos/location';

export enum SubmissionType {
  ELECTRONIC = 'Elektronisch',
  WRITTEN = 'Schriftlich',
}

export interface Submission extends BaseEntity {
  languages: string[];
  multipleSubmissionsAllowed?: boolean;
  alternativeSubmissionsAllowed?: boolean;
  allowedModes: SubmissionType[];
  url?: string;
  address?: Address;
}
